const accessMaintenance = {

    HIERARCHY: { name: 'Hierarchy', path: '/hierarchy' },
    SCHEDULED_LIST: { name: 'Scheduled List', path: '/scheduled-list' },
    CREATE_MAINTENANCE: { name: 'Create Maintenance', path: '/create-maintenance' },
    SCHEDULED_DETAILS: { name: 'Scheduled Details', path: '/scheduled-details' },

    PLAY: { name: 'Play', path: '/play' },
    HOLD: { name: 'Hold', path: '/hold' },
    STOP: { name: 'Stop', path: '/stop' },
    RESCHEDULE: { name: 'Reschedule', path: '/reschedule' },
    FEEDBACK: { name: 'Feedback', path: '/feedback' },
    PROSPECTIVE_DATE: { name: 'Prospective Date', path: '/prospective-date' },

}

export default accessMaintenance;